import React, { InputHTMLAttributes, useState } from 'react'
import { batch } from 'react-redux'

import {
  jdihSetIsEventFilter,
  jdihSetIsEventFilterFirstTime,
  jdihSetSelected,
  jdihSetSkip,
  jdihSetYear,
} from '@/reducers/jdih'
import clsxm from '@/utils/clsxm'
import { OptionObject } from '@/utils/form'
import { useAppDispatch, useAppSelector } from '@/utils/hooks'

import IcChecked from '~/assets/icons/radio-checked.svg'
import IcUnchecked from '~/assets/icons/radio-unchecked.svg'

interface SelectComponentProps extends InputHTMLAttributes<HTMLDivElement> {
  options: OptionObject[]
  placeholder?: string
}

const SelectComponent: React.FC<SelectComponentProps> = ({ options, placeholder = 'Choose', ...rest }) => {
  const dispatch = useAppDispatch()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const jdihYear = useAppSelector((state) => state.Jdih.year)
  const handleSelect = (value: string) => {
    setDropdownOpen(false)
    batch(() => {
      dispatch(jdihSetYear(value))
      dispatch(jdihSetIsEventFilter(true))
      dispatch(jdihSetSkip(0))
      dispatch(jdihSetSelected(0))
      dispatch(jdihSetIsEventFilterFirstTime(true))
    })
  }

  return (
    <div className='relative flex h-full flex-col gap-2'>
      <div
        {...rest}
        className={clsxm(
          'flex h-full cursor-pointer items-center justify-between rounded-lg border border-neutral-border px-3 py-2.5',
          dropdownOpen && 'border-2 border-red/25',
          rest.className
        )}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <p
          className={clsxm(
            'select-none whitespace-nowrap text-sm font-medium',
            jdihYear != null ? 'text-black' : 'text-form-placeholder'
          )}
        >
          {options.find((opt) => opt.value == jdihYear)?.label || placeholder}
        </p>

        <div className='flex cursor-pointer items-center justify-center'>
          <i className={clsxm('text-2xl text-black', dropdownOpen ? 'kek-arrow-up-s-line' : 'kek-arrow-down-s-line')} />
        </div>
      </div>

      {dropdownOpen && (
        <div
          className={clsxm(
            'absolute right-0 top-15 h-[244px] w-full rounded-lg bg-white p-3 pr-1.5 shadow-dropdown lg:w-[240px]'
          )}
        >
          <div className='h-full overflow-y-auto pr-1.5'>
            {options.map((opt) => (
              <div
                key={opt.value}
                className={clsxm(
                  'flex h-11 cursor-pointer items-center justify-between gap-2 rounded-lg px-3 py-2.5',
                  opt.value == jdihYear && 'bg-orange'
                )}
                onClick={() => handleSelect(opt.value)}
              >
                <p
                  className={clsxm('text-sm -tracking-[0.084px]', opt.value == jdihYear ? 'text-black' : 'text-gray-2')}
                >
                  {opt.label}
                </p>

                {opt.value == jdihYear ? (
                  <IcChecked className={clsxm('block h-5 w-5')} />
                ) : (
                  <IcUnchecked className={clsxm('block h-5 w-5')} />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default SelectComponent
